__turbopack_context__.v({
  "alert": "krails-capabilities-module__GiQDYG__alert",
  "bg": "krails-capabilities-module__GiQDYG__bg",
  "body": "krails-capabilities-module__GiQDYG__body",
  "brandLtr": "krails-capabilities-module__GiQDYG__brandLtr",
  "card": "krails-capabilities-module__GiQDYG__card",
  "errors": "krails-capabilities-module__GiQDYG__errors",
  "glow": "krails-capabilities-module__GiQDYG__glow",
  "grid": "krails-capabilities-module__GiQDYG__grid",
  "hero": "krails-capabilities-module__GiQDYG__hero",
  "heroBody": "krails-capabilities-module__GiQDYG__heroBody",
  "heroCopy": "krails-capabilities-module__GiQDYG__heroCopy",
  "heroMedia": "krails-capabilities-module__GiQDYG__heroMedia",
  "loop": "krails-capabilities-module__GiQDYG__loop",
  "loopCopy": "krails-capabilities-module__GiQDYG__loopCopy",
  "loopFlow": "krails-capabilities-module__GiQDYG__loopFlow",
  "loopInner": "krails-capabilities-module__GiQDYG__loopInner",
  "meshA": "krails-capabilities-module__GiQDYG__meshA",
  "meshB": "krails-capabilities-module__GiQDYG__meshB",
  "program": "krails-capabilities-module__GiQDYG__program",
  "programMedia": "krails-capabilities-module__GiQDYG__programMedia",
  "rails": "krails-capabilities-module__GiQDYG__rails",
  "railsMedia": "krails-capabilities-module__GiQDYG__railsMedia",
  "section": "krails-capabilities-module__GiQDYG__section",
  "title": "krails-capabilities-module__GiQDYG__title",
  "titleOnGradient": "krails-capabilities-module__GiQDYG__titleOnGradient",
  "verified": "krails-capabilities-module__GiQDYG__verified",
  "verifiedPanel": "krails-capabilities-module__GiQDYG__verifiedPanel",
});
